import React from 'react';

export const levelOptions = [
  { value: 10, label: 'Viewer (10)' },
  { value: 50, label: 'Editor (50)' },
  { value: 80, label: 'Admin (80)' },
  { value: 90, label: 'Owner (90)' },
  { value: 100, label: 'Superadmin (100)' },
];

export const levelHelp = (
  <div>
    <div><strong>Access Levels</strong></div>
    <div>100: Superadmin — full platform access</div>
    <div>90: Owner — full admin for this scope</div>
    <div>80: Admin — manage settings & users</div>
    <div>50: Editor — edit content, no admin</div>
    <div>10: Viewer — read-only</div>
    <div>0: None — no access</div>
  </div>
);
